import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

interface ModalProps {
  onBackdropClick?: Function;
}

const modalRoot = document.getElementById('modal');
const modalElement = document.createElement('div');

const Modal: React.FC<ModalProps> = ({ children, onBackdropClick }) => {
  useEffect(() => {
    modalRoot?.appendChild(modalElement);
    return () => {
      modalRoot?.removeChild(modalElement);
    };
  });

  return ReactDOM.createPortal(
    <div
      className="modal-wrapper"
      onClick={() => onBackdropClick && onBackdropClick()}
    >
      <div onClick={(event) => event.stopPropagation()}>{children}</div>
    </div>,
    modalElement
  );
};

export default Modal;
